import { createRouter, createWebHashHistory, createWebHistory, useRouter } from 'vue-router';
import routes from './routes';
import { v4 as uuidv4 } from 'uuid';
import { getCurrentTabId, getCountTab } from '@/utils/tab-router-utils';
import { getLocal } from '@/utils/local';
import { useUserStore } from '@/components/loginUser/useUserStore';

const APP_BASE_PATH = import.meta.env.APP_BASE_PATH;

let router = createRouter({
  routes,
  history: createWebHistory(APP_BASE_PATH),
  scrollBehavior() {
    return { top: 0 };
  },
});

router.beforeEach(async (to, from) => {
  // 用户登录状态判断
  const userId = getLocal('userId');
  if (to.path !== '/') {
    // 生产环境登录校验
    if (import.meta.env.MODE === 'fz' || import.meta.env.MODE === 'zs') {
      if (!userId) {
        return {
          path: '/',
          query: { redirect: to.fullPath }, // 保存原路径用于登录后跳转
        };
      }
    }

    // 登录失效校验
    try {
      // 登录失效校验
      await useUserStore().expireToken();
    } catch (error) {
      return {
        path: '/',
        query: { redirect: to.fullPath }, // 保存原路径用于登录后跳转
      };
    }
  }
});

export default router;
